module.exports = __webpack_public_path__ + "static/media/opinionesFlor.dfcaaee7.jpg";